import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-delivery-reports',
  templateUrl: './delivery-reports.component.html',
  styleUrls: ['./delivery-reports.component.scss']
})
export class DeliveryReportsComponent implements OnInit {

  title = 'Reports';

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

  }


}
